module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showComponent) ? _c('div', {
    staticClass: "flex w-100 flex-column pa3 pl4 pr4 justify-around br3 mt4 mb3 container",
    class: !_vm.isValidCode ? 'containerError' : ''
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [(_vm.isValidCode) ? _c('valid-icon', {
    class: _vm.iconClass
  }) : _c('invalid-icon', {
    class: _vm.iconClass
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('label', {
    staticClass: "f6 silver inter margin lh-copy"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), (!_vm.isValidCode) ? _c('label', {
    staticClass: "f6 silver inter margin lh-copy"
  }, [_vm._v("\n      If you think this is an error, please "), _c('a', {
    staticClass: "color-theme underline",
    on: {
      "click": _vm.openIntercomChat
    }
  }, [_vm._v("contact our support team.")])]) : _vm._e(), _vm._v(" "), (_vm.isValidCode) ? _c('div', {
    staticClass: "flex margin mt2"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [(!!_vm.$store.state.activation.coverage.name) ? _c('label', {
    staticClass: "f7 silver inter mb2"
  }, [_vm._v("\n          PLAN\n        ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "f6 inter"
  }, [_vm._v(_vm._s(_vm.$store.state.activation.coverage.name))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column ml5 retail"
  }, [_c('label', {
    staticClass: "f7 silver inter mb2"
  }, [_vm._v("SUPPLIER")]), _vm._v(" "), _c('label', {
    staticClass: "f6 inter"
  }, [_vm._v(_vm._s(_vm.$store.state.registration.redemption.supplier))])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e37feb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/forms/CodeMessage.vue
// module id = 670
// module chunks = 0